// import React from "react";

// interface NoDataProps {
//   title?: string;
//   message?: string;
//   imageSrc?: string;
//   mainClassName?: string;
//   subClassName?: string;
// }

// const NoDataFound: React.FC<NoDataProps> = ({
//   title = "No Data Found",
//   message = "Try adjusting your filters or come back later.",
//   imageSrc = "./img/data-not-found.png",
//   mainClassName = "bg-[#F7F6F2] pt-2 rounded-r-3xl rounded-b-3xl",
//   subClassName = "bg-[#FCFDF8]",
// }) => {
//   return (
//     <div className={` ${mainClassName}`}>
//       <div
//         className={`${subClassName} rounded-b-3xl rounded-r-3xl flex flex-col items-center justify-center text-center py-12 text-gray-500`}
//       >
//         <img src={imageSrc} alt="No Data" className="w-24 h-24 mb-4" />
//         <h3 className="text-2xl font-semibold text-[#212121]">{title}</h3>
//         <p className="text-base text-[#212121]/70 mt-1">{message}</p>
//       </div>
//     </div>
//   );
// };

// export default NoDataFound;



import React from "react"; 
import ButtonStyled from "./ButtonStyled"; 

interface NoDataFoundProps {
  title?: string;
  message?: string;
  imageSrc?: string;
  buttonText?: string;
  mainClassName?: string;
  subClassName?: string;
  classHeading?: string;
  classParagraph?: string;
  onButtonClick?: () => void;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  title = "No Data Found",
  message = "Looks like you haven't added anything yet.",
  buttonText = "Add New Data",
  imageSrc = "",
  mainClassName = "bg-[#F7F6F2] pt-2 rounded-r-3xl rounded-b-3xl",
  subClassName = "bg-[#FCFDF8]",
  classHeading = "text-[#212121]",
  classParagraph = "text-[#212121]/70",
  onButtonClick,
}) => {
  return (
    <div className="w-full flex items-center justify-center py-10">
      <div
        className="
          relative
          w-full
          max-w-[380px]
          overflow-hidden
          rounded-[18px]
          border
          border-slate-100
        
          px-6
          py-7
          text-center 
        "
      >
        {/* Decorative dots */}
        <span className="absolute left-[64px] top-[66px] h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute left-[85px] top-[70px] h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute left-[105px] top-[110px] h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute right-[78px] top-[82px] h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute bottom-[85px]  h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute left-[95px] top-[82px] h-1.5 w-1.5 rounded-full bg-[#FBD037]" />
        <span className="absolute right-[101px] top-[28px] h-1.5 w-1.5 rounded-full border border-[#FBD037]" />
        <span className="absolute right-[10px] top-[28px] h-1.5 w-1.5 rounded-full border border-[#FBD037]" />
        <span className="absolute right-[110px] top-[38px] h-1.5 w-1.5 rounded-full border border-[#FBD037]" />
        <span className="absolute right-[110px] top-[38px] h-1.5 w-1.5 rounded-full border border-[#FBD037]" />
        <span className="absolute left-[110px] bottom-[38px] h-1.5 w-1.5 rounded-full border border-[#FBD037]" />

        {/* Illustration */}
        <div className="relative mx-auto mb-4 flex h-[105px] w-[120px] items-center justify-center">
          {/* Magnifying glass */}
          <div className="relative h-[53px] w-[53px] rounded-full border-[6px] border-[#FBD037]/60">
            {/* face */}
            <div className="absolute left-[10px] top-[14px] flex gap-[9px]">
              <span className="h-[5px] w-[5px] rounded-full bg-[#FBD037]" />
              <span className="h-[5px] w-[5px] rounded-full bg-[#FBD037]" />
            </div>

            {/* mouth */}
            <div className="absolute left-[15px] top-[29px] h-[3px] w-[9px] rounded-full bg-[#FBD037]" />

            {/* blue reflection */}
            <span className="absolute -right-[10px] top-[8px] h-[10px] w-[10px] rounded-full bg-[#FBD037]" />
          </div>

          {/* Magnifier handle */}
          <div
            className="
              absolute
              left-[80px]
              top-[70px]
              h-[34px]
              w-[16px]
              rotate-[-42deg]
              rounded-[4px]
              bg-[#FBD037]/60
            "
          />
        </div>

        {/* Content */}
        <h3 className="mb-1.5 text-[20px] font-extrabold tracking-tight text-[#212121]">
          {title}
        </h3>

        <p className="mx-auto   text-[13px] font-medium leading-[19px] text-[#212121]/70">
          {message}
        </p>

        {/* Button */}
        {onButtonClick && (
          <div className="flex justify-center items-center pt-2">
            <ButtonStyled onClick={onButtonClick} value={buttonText} />
          </div>
        )}
      </div>
    </div>
  );
};

export default NoDataFound;